import React,{useState} from 'react';
import { Button,Table,Container,Row,Col,Form,Modal } from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRupeeSign,faEdit,faTrashAlt,faShareSquare,faHourglassHalf,faCloudDownloadAlt,faMoneyCheck,faCheck } from '@fortawesome/free-solid-svg-icons';


import Loginheader from '../Loginheader';
import Menu from '../Menu';

function InProgress1(){
    
    const [showCvr, setShowCvr] = useState(false);
    const [showAddTcsGst,setShowAddTcsGst] = useState(false);
    const [showAddMoreDtl,setShowAddMoreDtl] = useState(false);
    const [showBankFileDown,setShowBankFileDown] = useState(false);
    const [showCancelRequest,setShowCancelRequest] = useState(false);
    const [showInvoiceDownload,setShowInvoiceDownload] = useState(false);
    const [showUploadInvoiceSwift,setUploadInvoiceSwift] = useState(false);
    
    function searchRequest(){}
    function resetSearch(){}
    function showCoverWindow(){
        setShowCvr(true);
    }
    function showTcsGstWindow(){
        setShowAddTcsGst(true);
    }

    function showAddMoreDtlWindow(){
        setShowAddMoreDtl(true);
    }

    function showBankFileDownWindow(){
        setShowBankFileDown(true);
    }

    function showCancelRequestWindow(){
        setShowCancelRequest(true);
    }

    function showInvoiceDownloadWindow(){
        setShowInvoiceDownload(true);
    }

    function showUploadInvoiceSwiftWindow(){
        setUploadInvoiceSwift(true);
    }

    return(
        <>
            <Loginheader></Loginheader>
            <Menu></Menu>
            <Container fluid >
                <Row>
                    <Col>
                        <h1>In Progress</h1>
                    </Col>
                </Row>   
                <Row>
                    <Col>
                        <Form>
                            <Row>
                                <Col>
                                    <Form.Group controlId="txtStatus">
                                        <Form.Label>Status</Form.Label>
                                        <Form.Select aria-label="Default select example">
                                            <option selected>All</option>
                                            <option>New Rquest</option>
                                            <option>Deal No. Assigned</option>
                                            <option>Forwarded To Backoffice</option>
                                            <option>Forwarded To Bank</option>
                                            <option>Swift Copy Received</option>
                                            <option>Cancelled</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group controlId="txtRefNo">
                                        <Form.Label>Reference Number</Form.Label>
                                        <Form.Control type="text" placeholder="Reference No" />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group controlId="txtFromDate">
                                        <Form.Label>From Date</Form.Label>
                                        <Form.Control type="text" placeholder="DD/MM/YYYY" />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group controlId="txtToDate">
                                        <Form.Label>To Date</Form.Label>
                                        <Form.Control type="text" placeholder="DD/MM/YYYY" />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group controlId="txtSearch">
                                        <Form.Label>&nbsp;</Form.Label>
                                        <div>
                                            <Button  variant="outline-primary" size="sm"  onClick={()=>searchRequest()}>Search</Button>&nbsp;
                                            <Button  variant="outline-danger" size="sm"  onClick={()=>resetSearch()}>Reset</Button>                                
                                        </div>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                </Row>
                <Row><Col>&nbsp;</Col></Row>  
                {/** Table */}
                <Row>
                    <Col>
                        <Table responsive striped bordered hover>
                            <thead>
                                <tr>
                                    <td>Sr. No.</td>
                                    <td>Reference No</td>
                                    <td>Branch</td>
                                    <td>Agent</td>
                                    <td>Currency</td>
                                    <td>Quantity</td>
                                    <td>Sell Rate</td>
                                    <td>Cover Rate</td>
                                    <td>Status</td>
                                </tr>
                            </thead>
                            <tbody> 
                                {/** First Row */}
                                
                                    <tr>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td>
                                        <div className="colorThemeBlue">
                                            <span className="handCursor" onClick={(e)=>showCoverWindow()}>
                                                <FontAwesomeIcon icon={faRupeeSign}  />
                                            </span>&nbsp;
                                            <span className="handCursor" onClick={(e)=>showTcsGstWindow()}>
                                                <FontAwesomeIcon icon={faEdit}  />
                                            </span>&nbsp;
                                            <span className="handCursor"  onClick={(e)=>showAddMoreDtlWindow()}>
                                                <FontAwesomeIcon icon={faShareSquare}  />
                                            </span>&nbsp;
                                            <span className="handCursor">
                                                <FontAwesomeIcon icon={faTrashAlt}  onClick={(e)=>showCancelRequestWindow()}  />
                                            </span>&nbsp;
                                            <span className="handCursor">
                                                <FontAwesomeIcon icon={faMoneyCheck} onClick={(e)=>showBankFileDownWindow()}  />
                                            </span>&nbsp;
                                            <span className="handCursor">
                                                <FontAwesomeIcon icon={faHourglassHalf}  />
                                            </span>&nbsp;
                                            <span className="handCursor">
                                                <FontAwesomeIcon icon={faCloudDownloadAlt} onClick={(e)=>showInvoiceDownloadWindow()}  />
                                            </span>&nbsp;
                                            <span className="handCursor">
                                                <FontAwesomeIcon icon={faCheck}  onClick={(e)=>showUploadInvoiceSwiftWindow()} />
                                            </span>&nbsp;
                                        </div>
                                    </td>
                                    </tr>                                    
                                

                                <tr>
                                    <td>5</td>
                                    <td>2020/DEL/SP5</td>
                                    <td>1 JanakPuri</td>
                                    <td>1 Agent Name</td>
                                    <td>USD</td>
                                    <td>1000</td>
                                    <td>75.42</td>
                                    <td>75.01</td>
                                    <td>New Request</td>
                                    <td>
                                        <div className="colorThemeBlue">
                                            <span className="handCursor">
                                                <FontAwesomeIcon icon={faRupeeSign}  />
                                            </span>&nbsp;
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>4</td>
                                    <td>2020/DEL/SP4</td>
                                    <td>1 JanakPuri</td>
                                    <td>1 Agent Name</td>
                                    <td>USD</td>
                                    <td>1000</td>
                                    <td>75.42</td>
                                    <td>75.01</td>
                                    <td>Deal No. Assigned</td>
                                    <td>
                                        <div className="colorThemeBlue">
                                            <span className="handCursor">
                                                <FontAwesomeIcon icon={faEdit}  />
                                            </span>&nbsp;
                                            <span className="handCursor">
                                                <FontAwesomeIcon icon={faShareSquare}  />
                                            </span>&nbsp;
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>3</td>
                                    <td>2020/DEL/SP3</td>
                                    <td>1 JanakPuri</td>
                                    <td>1 Agent Name</td>
                                    <td>USD</td>
                                    <td>1000</td>
                                    <td>75.42</td>
                                    <td>75.01</td>
                                    <td>Forwarded To Backoffice</td>
                                    <td>
                                        <div className="colorThemeBlue">
                                            <span className="handCursor">
                                                <FontAwesomeIcon icon={faMoneyCheck}  />
                                            </span>&nbsp;
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>2</td>
                                    <td>2020/DEL/SP2</td>
                                    <td>1 JanakPuri</td>
                                    <td>1 Agent Name</td>
                                    <td>USD</td>
                                    <td>1000</td>
                                    <td>75.42</td>
                                    <td>75.01</td>
                                    <td>Forwarded To Bank</td>
                                    <td>
                                        <div className="colorThemeBlue">
                                            <span className="handCursor">
                                                <FontAwesomeIcon icon={faCheck}  />
                                            </span>&nbsp;
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>1</td>
                                    <td>2020/DEL/SP1</td>
                                    <td>1 JanakPuri</td>
                                    <td>1 Agent Name</td>
                                    <td>USD</td>
                                    <td>1000</td>
                                    <td>75.42</td>
                                    <td>75.01</td>
                                    <td>Swift Copy Received</td>
                                    <td>
                                        <div className="colorThemeBlue">
                                            <span className="handCursor">
                                                <FontAwesomeIcon icon={faCloudDownloadAlt}  />
                                            </span>&nbsp;
                                        </div>
                                    </td>
                                </tr>
                                {/**
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>
                                                <div className="colorThemeBlue">
                                                    <span className="handCursor">
                                                        <FontAwesomeIcon icon={faRupeeSign}  />
                                                    </span>&nbsp;
                                                    <span className="handCursor">
                                                        <FontAwesomeIcon icon={faEdit}  />
                                                    </span>&nbsp;
                                                    <span className="handCursor">
                                                        <FontAwesomeIcon icon={faShareSquare}  />
                                                    </span>&nbsp;
                                                    <span className="handCursor">
                                                        <FontAwesomeIcon icon={faTrashAlt}  />
                                                    </span>&nbsp;
                                                    <span className="handCursor">
                                                        <FontAwesomeIcon icon={faMoneyCheck}  />
                                                    </span>&nbsp;
                                                    <span className="handCursor">
                                                        <FontAwesomeIcon icon={faHourglassHalf}  />
                                                    </span>&nbsp;
                                                    <span className="handCursor">
                                                        <FontAwesomeIcon icon={faCloudDownloadAlt}  />
                                                    </span>&nbsp;
                                                    <span className="handCursor">
                                                        <FontAwesomeIcon icon={faCheck}  />
                                                    </span>&nbsp;
                                                </div>
                                            </td>
                                        </tr>
                                
                                */}

                            </tbody>
                        </Table>
                    </Col>
                </Row>       
            </Container>
            
                {/** Cover rate modal */}
                <Modal
                    show={showCvr}
                    onHide={() => setShowCvr(false)}
                    size="xl"
                    centered
                    >
                    <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title">
                        Cover Rate
                    </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="divCostumForm">
                            <Row>
                                <Col>Product : TT</Col>
                                <Col>Type : GIC</Col>
                                <Col>Serial Number : 12345</Col>
                                <Col>Reference Number : 12345</Col>
                            </Row>
                            <Row>
                                <Col>Currency: USD</Col>
                                <Col>Quantity: 10000</Col>
                                <Col>Sell Rate: 78.80 </Col>
                                <Col>Purpose: S101-HHHHHHHHH</Col> 
                            </Row>
                            <Row>
                                <Col>Beneficiary Country: USA</Col>
                                <Col>Value Date: 07-12-2021</Col>
                                <Col>Nostro Charges : BEN </Col>
                                <Col>BANK : ICICI BANK</Col>
                            </Row>
                            <Row>
                                <Col>
                                    <hr/>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Group controlId="txtCoverRate">
                                        <Form.Label>Cover Rate</Form.Label>
                                        <Form.Control type="text" placeholder="Cover Rate" />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group controlId="txtDealNo">
                                        <Form.Label>Deal Number</Form.Label>
                                        <Form.Control type="text" placeholder="Deal Number" />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    &nbsp;
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Button  variant="outline-success" size="sm" >Save</Button>&nbsp;
                                    <Button  variant="outline-danger" size="sm" >Reset</Button>
                                </Col>
                            </Row>                    
                        </div>
                    </Modal.Body>
                </Modal>

                {/** Additional Information */}
                <Modal
                    show={showAddTcsGst}
                    onHide={() => setShowAddTcsGst(false)}
                    size="xl"
                    centered
                    >
                    <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title">
                        TCS and GST Update
                    </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="divCostumForm">
                            <Row>
                                <Col>Product : TT</Col>
                                <Col>Type : GIC</Col>
                                <Col>Serial Number : 12345</Col>
                                <Col>Reference Number : 12345</Col>
                            </Row>
                            <Row>
                                <Col>Currency: USD</Col>
                                <Col>Quantity: 10000</Col>
                                <Col>Sell Rate: 78.80 </Col>
                                <Col>Purpose: S101-HHHHHHHHH</Col> 
                            </Row>
                            <Row>
                                <Col>Beneficiary Country: USA</Col>
                                <Col>Value Date: 07-12-2021</Col>
                                <Col>Nostro Charges : BEN </Col>
                                <Col>BANK : ICICI BANK</Col>
                            </Row>
                            <Row>
                                <Col>
                                    <hr/>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Group controlId="txtTcsAmnt">
                                        <Form.Label>TCS Amount</Form.Label>
                                        <Form.Control type="text" placeholder="TCS Amount" />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group controlId="txtGstAmnt">
                                        <Form.Label>GST Amount</Form.Label>
                                        <Form.Control type="text" placeholder="GST Amount" />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    &nbsp;
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Button  variant="outline-success" size="sm" >Save</Button>&nbsp;
                                    <Button  variant="outline-danger" size="sm" >Reset</Button>
                                </Col>
                            </Row>                    
                        </div>
                    </Modal.Body>
                </Modal>

                {/*** Add More Infromation */}              
                <Modal
                    show={showAddMoreDtl}
                    onHide={() => setShowAddMoreDtl(false)}
                    size="xl"
                    centered
                    >
                    <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title">
                        Additional Details
                    </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="divCostumForm">
                            <Row>
                                <Col>Product : TT</Col>
                                <Col>Type : GIC</Col>
                                <Col>Serial Number : 12345</Col>
                                <Col>Reference Number : 12345</Col>
                            </Row>
                            <Row>
                                <Col>Currency: USD</Col>
                                <Col>Quantity: 10000</Col>
                                <Col>Sell Rate: 78.80 </Col>
                                <Col>Purpose: S101-HHHHHHHHH</Col> 
                            </Row>
                            <Row>
                                <Col>Beneficiary Country: USA</Col>
                                <Col>Value Date: 07-12-2021</Col>
                                <Col>Nostro Charges : BEN </Col>
                                <Col>BANK : ICICI BANK</Col>
                            </Row>
                            <Row>
                                <Col>
                                    <hr/>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <h5>Payment Details</h5>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Group controlId="txtStatus">
                                        <Form.Label>Bank </Form.Label>
                                        <Form.Select aria-label="Default select example">
                                            <option>ICICI Bank</option>
                                            <option>Indusind Bank</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group controlId="txtBankRefNo">
                                        <Form.Label>Bank Reference No</Form.Label>
                                        <Form.Control type="text" placeholder="Reference Number" />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group controlId="txtInrAmnt">
                                        <Form.Label>INR Amount</Form.Label>
                                        <Form.Control type="text" placeholder="INR Amount" />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <hr></hr>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <h5>Remitter Details</h5>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Group controlId="txtBenCountry">
                                        <Form.Label>Client Type<span className="mandatory">*</span></Form.Label>
                                        <Form.Select aria-label="Default select example">
                                            <option>Individual</option>
                                            <option>Corporate</option>
                                        </Form.Select>
                                    </Form.Group>                                
                                </Col>
                                <Col>
                                    <Form.Group controlId="txtBenName">
                                        <Form.Label>Client Name<span className="mandatory">*</span></Form.Label>
                                        <Form.Control type="text" placeholder="Client Name" />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group controlId="txtBenName">
                                        <Form.Label>Date of Birth<span className="mandatory">*</span></Form.Label>
                                        <Form.Control type="text" placeholder="Date of Birth" />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Group controlId="txtBenName">
                                        <Form.Label>Passport Number<span className="mandatory">*</span></Form.Label>
                                        <Form.Control type="text" placeholder="Date of Birth" />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group controlId="txtBenName">
                                        <Form.Label>Aadhar Number<span className="mandatory">*</span></Form.Label>
                                        <Form.Control type="text" placeholder="Aadhar Number" />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group controlId="txtBenName">
                                        <Form.Label>Remitter Address<span className="mandatory">*</span></Form.Label>
                                        <Form.Control type="text" placeholder="Remitter Address" />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Group controlId="txtBenName">
                                        <Form.Label>Occupation<span className="mandatory">*</span></Form.Label>
                                        <Form.Control type="text" placeholder="Remitter Address" />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group controlId="txtBenName">
                                        <Form.Label>Annual Income<span className="mandatory">*</span></Form.Label>
                                        <Form.Control type="text" placeholder="Annual Income" />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    &nbsp;
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <hr></hr>
                                </Col>
                            </Row>    
                            <Row>
                                <Col>
                                    <h5>Beneficiary Details</h5>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Group controlId="txtBenName">
                                        <Form.Label>Beneficiary Name<span className="mandatory">*</span></Form.Label>
                                        <Form.Control type="text" placeholder="Beneficiary Name" />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group controlId="txtBenCountry">
                                        <Form.Label>Beneficiary Country<span className="mandatory">*</span></Form.Label>
                                        <Form.Select aria-label="Default select example">
                                            <option>USA</option>
                                            <option>UK</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group controlId="txtBenAdd">
                                        <Form.Label>Beneficiary Address<span className="mandatory">*</span></Form.Label>
                                        <Form.Control type="text" placeholder="Beneficiary Address" />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Group controlId="txtBenBank">
                                        <Form.Label>Beneficiary Bank<span className="mandatory">*</span></Form.Label>
                                        <Form.Control type="text" placeholder="Beneficiary Bank" />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group controlId="txtBenBankAcctNo">
                                        <Form.Label>Beneficiary Acount No<span className="mandatory">*</span></Form.Label>
                                        <Form.Control type="text" placeholder="Beneficiary Account No" />
                                    </Form.Group>   
                                </Col>
                                <Col >
                                    <Form.Group controlId="txtBenBankAdd">
                                        <Form.Label>Beneficiary Bank Address<span className="mandatory">*</span></Form.Label>
                                        <Form.Control type="text" placeholder="Beneficiary Bank Address" />
                                    </Form.Group>                            
                                </Col>
                            </Row>
                            <Row>
                                <Col >
                                    <Form.Group controlId="txtBenBankAdd">
                                        <Form.Label>Swift Code</Form.Label>
                                        <Form.Control type="text" placeholder="Swift Code" />
                                    </Form.Group>                            
                                </Col>
                                <Col >
                                    <Form.Group controlId="txtIBankNo">
                                        <Form.Label>IBAN No.</Form.Label>
                                        <Form.Control type="text" placeholder="IBAN No" />
                                    </Form.Group>                            
                                </Col>
                                <Col>
                                    <Form.Group controlId="txtRoutNo">
                                        <Form.Label>Routing No.(For USD)</Form.Label>
                                        <Form.Control type="text" placeholder="Routing No" />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col >
                                    <Form.Group controlId="txtBenBankAdd">
                                        <Form.Label>Sort Code (For GBP)</Form.Label>
                                        <Form.Control type="text" placeholder="Sort Code" />
                                    </Form.Group>                            
                                </Col>
                                <Col >
                                    <Form.Group controlId="txtIBankNo">
                                        <Form.Label>BSB No.(For AUD)</Form.Label>
                                        <Form.Control type="text" placeholder="BSB No" />
                                    </Form.Group>                            
                                </Col>
                                <Col>
                                    <Form.Group controlId="txtRoutNo">
                                        <Form.Label>Transit No.(For CAD)</Form.Label>
                                        <Form.Control type="text" placeholder="Transit No" />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={6}>
                                    <Form.Group controlId="txtRoutNo">
                                        <Form.Label>Student Details</Form.Label>
                                        <Form.Control type="text" placeholder="Student Details" />
                                    </Form.Group>
                                </Col>
                                <Col xs={6}>
                                    <Form.Group controlId="txtRoutNo">
                                        <Form.Label>Other Details</Form.Label>
                                        <Form.Control type="text" placeholder="Other Details" />
                                    </Form.Group>
                                </Col>
                            
                            </Row>
                            <Row>
                                <Col>
                                    <hr></hr>
                                </Col>
                            </Row>    
                            <Row>
                                <Col>
                                    <h5>Correspondent Bank Details</h5>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Group controlId="txtRoutNo">
                                        <Form.Label>Bank Name</Form.Label>
                                        <Form.Control type="text" placeholder="Bank Name" />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group controlId="txtRoutNo">
                                        <Form.Label>Bank Account No</Form.Label>
                                        <Form.Control type="text" placeholder="Bank Account No" />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group controlId="txtRoutNo">
                                        <Form.Label>Bank Country</Form.Label>
                                        <Form.Control type="text" placeholder="Bank Country" />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Group controlId="txtRoutNo">
                                        <Form.Label>Bank Address</Form.Label>
                                        <Form.Control type="text" placeholder="Bank Address" />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <hr></hr>
                                </Col>
                            </Row>    
                            <Row>
                                <Col>
                                    <h5>Documents</h5>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Group controlId="txtRoutNo">
                                        <Form.Label>KYC Document</Form.Label>
                                        <Form.Control type="file"  />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group controlId="txtRoutNo">
                                        <Form.Label>Bank Statement</Form.Label>
                                        <Form.Control type="file"  />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    &nbsp;
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Button  variant="outline-success" size="sm" >Save</Button>&nbsp;
                                    <Button  variant="outline-danger" size="sm" >Reset</Button>
                                </Col>
                            </Row>                    
                        </div>
                    </Modal.Body>
                </Modal>

                {/*** Bank File Download */}              
                <Modal
                    show={showBankFileDown}
                    onHide={() => setShowBankFileDown(false)}
                    size="xl"
                    centered
                    >
                    <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title">
                        Bank File Download
                    </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                    <Row>
                        <Col>
                            <ul className="ulListStyleNone">
                                <li >
                                    <span className="handCursor">
                                        <FontAwesomeIcon icon={faCloudDownloadAlt} onClick={(e)=>showInvoiceDownloadWindow()}  />
                                    </span>&nbsp;Download Bank File (Updated on DD/MM/YYYY)
                                </li>
                            </ul>
                        </Col>
                    </Row>
                    </Modal.Body>
                </Modal>

                {/** Cancel Request Records */}
                <Modal
                    show={showCancelRequest}
                    onHide={() => setShowCancelRequest(false)}
                    size="xl"
                    centered
                    >
                    <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title">
                        Cancel request if not completed on validations
                    </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                                This will give option to cancel .
                    </Modal.Body>
                </Modal>
                {/** Download Invoice Swift Copy */}
                <Modal
                    show={showInvoiceDownload}
                    onHide={() => setShowInvoiceDownload(false)}
                    size="xl"
                    centered
                    >
                    <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title">
                        Download Invoice And Swift Copy
                    </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            <Col>
                                <ul className="ulListStyleNone">
                                    <li >
                                        <span className="handCursor">
                                            <FontAwesomeIcon icon={faCloudDownloadAlt} onClick={(e)=>showInvoiceDownloadWindow()}  />
                                        </span>&nbsp;Download Swift Copy (Updated on DD/MM/YYYY)
                                    </li>
                                    <li>
                                        <span className="handCursor">
                                            <FontAwesomeIcon icon={faCloudDownloadAlt} onClick={(e)=>showInvoiceDownloadWindow()}  />
                                        </span>&nbsp;Download Invoice Copy (Updated on DD/MM/YYYY)
                                    </li>
                                </ul>
                            </Col>
                        </Row>

                    </Modal.Body>
                </Modal>
                {/** Mark Completed Upload Swift Copy */}
                <Modal
                    show={showUploadInvoiceSwift}
                    onHide={() => setUploadInvoiceSwift(false)}
                    size="xl"
                    centered
                    >
                    <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title">
                        Upload Invoice and Swift Copy
                    </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            <Col>
                                <ul>
                                    <li>Swift Copy Uploaded on DD/MM/YYYY</li>
                                    <li>Invoice Uploaded on DD/MM/YYYY</li>
                                </ul>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group controlId="txtRoutNo">
                                    <Form.Label>Upload Swift Copy</Form.Label>
                                    <Form.Control type="file"  />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group controlId="txtRoutNo">
                                    <Form.Label>Upload Invoice</Form.Label>
                                    <Form.Control type="file"  />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                                <Col>&nbsp;</Col>
                        </Row>
                        <Row>
                            <Col>
                                <Button  variant="outline-success" size="sm"  onClick={()=>resetSearch()}>Upload</Button>                                
                            </Col>
                            <Col>
                                <Button  variant="outline-success" size="sm"  onClick={()=>resetSearch()}>Upload</Button>                                
                            </Col>                        
                        </Row>
                    </Modal.Body>
                </Modal>
        </>
    );
}
export default InProgress1;


  